import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAddresses } from "../../reduxStore/entities/address";
import UserAddressesTable from "../Tables/Table/UserAddressesTable";
import PlusIconBlackSVG from "../../../SharedComponents/assets/icons/svg/PlusIconBlackSVG";
import { useNavigate } from "react-router-dom";
import RightArrowIconSVG from "../../../SharedComponents/assets/icons/svg/RightArrowIconSVG";
import Breadcrumb from "../../../SharedComponents/components/Breadcrumb/Breadcrumb";


const AddressesPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { addresses, isLoaded } = useSelector((state) => state.addresses);

    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);

    useEffect(() => {
        dispatch(getAddresses());
    }, [dispatch]);

    const handleRowSelect = (addressId) => {
        navigate("/edit-address");
    };
    const handleCreateOfferClick = () => {
        navigate("/create-address");
    };
    const handleGoHome = () => {
        navigate("/home");
    };
    const handleDelete = (addressId) => {
    };

    const breadcrumbs = [
        { title: "Početak", href: "/home" },
        { title: "Sve adrese" },
    ];

    return (
        <div>

            <div style={styles.topBar}>
                <div onClick={handleGoHome} style={styles.iconWrapper}>
                    <RightArrowIconSVG />
                </div>
                <Breadcrumb
                    title={"Sve adrese"}
                    breadcrumbs={breadcrumbs}
                />
            </div>
            <div style={styles.buttonWrapper}>
                <button onClick={handleCreateOfferClick} style={styles.addButton}>
                    Dodaj adresu <PlusIconBlackSVG />
                </button>
            </div>
            <div>
                {isLoaded ? (
                    <UserAddressesTable
                        count={addresses.length}
                        addresses={addresses}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        page={page}
                        setPage={setPage}
                        onRowSelect={handleRowSelect}
                        onDeleteAddress={handleDelete}
                    />
                ) : (
                    <p>Učitavanje adresa...</p>
                )}
            </div>
        </div>
    );
};

const styles = {
    buttonWrapper: {
        display: "flex",
        justifyContent: "center",
        marginBottom: 16,
    },
    addButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 12,
        border: "2px solid #000",
        backgroundColor: "#fff",
        color: "#000",
        fontWeight: "bold",
        fontSize: 16,
        cursor: "pointer",
        width: 160,
        height: 50,
        marginLeft: 100
    },
    topBar: {
        display: "flex",
    },
    iconWrapper: {
        filter: "brightness(0) saturate(100%)",
        scale: "80%",
        rotate: "180deg",
        paddingTop: "35px",
        cursor: "pointer"
    },
};

export default AddressesPage;
